import { getUserState } from '@carvana/core-auth';
import { datadogRum } from '@datadog/browser-rum';
import type { LDInspectionFlagUsedHandler } from 'launchdarkly-js-client-sdk';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import dynamic from 'next/dynamic';
import { type ReactNode } from 'react';

const LD_USER_KIND = 'user-data' as const;

const LDIdentifierClient = dynamic(() => import('./LDIdentifierClient'), { ssr: false });

const ldSdkKey = process.env.CARVANA_APP_LAUNCH_DARKLY_SDK_KEY;
const isBrowser = typeof window !== 'undefined';
const { user } = isBrowser
  ? (getUserState() as { user?: { user_id?: string } })
  : { user: undefined };
const userId = user?.user_id;
const ldContext = userId
  ? { kind: LD_USER_KIND, key: LD_USER_KIND, 'user-id': userId }
  : { kind: LD_USER_KIND, key: LD_USER_KIND };

type OwnProps = {
  children: ReactNode;
};

function LDProviderWrapper({ children }: OwnProps) {
  if (!ldSdkKey) {
    return <>{children}</>;
  }

  return (
    <LDProvider
      clientSideID={ldSdkKey}
      context={ldContext}
      options={{
        inspectors: [
          {
            name: 'dd-inspector',
            type: 'flag-used',
            method: ((key: string, detail: { value: unknown }) => {
              datadogRum.addFeatureFlagEvaluation(key, detail.value);
            }) as LDInspectionFlagUsedHandler['method']
          }
        ]
      }}
    >
      {children}
      <LDIdentifierClient />
    </LDProvider>
  );
}

export default LDProviderWrapper;
